<template>
  <div class="cp-times">
    <div class="box-content" v-html="text"></div>
    <div class="box-bottom">
      <div class="bottom-item" @click="showShare"></div>
    </div>
    <Close is-mobile @close="onClose" class="close"></Close>
  </div>
</template>

<script>
import Close from '~/components/Close/close.vue';
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import { mapState } from "vuex";
import { isWeiXin, getParameterByName, isAndroid } from "~/tools/utils";

export default {
  name: 'Alert',
  components: {Close},
  data() {
    return {
      visible: false,
      title: '',
      text: '',
      ingame: getParameterByName("ingame"),
      star: getParameterByName("star")
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    showShare() {
      let url = `${this.userInfo.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送：`
      store.commit(types.SHOW_MODAL, {type: 'copy', copy: url + window.location.origin + `/act/blc_carnival2024/#/share?fid=${this.userInfo.shareinfo.userid}`})
      // if(this.ingame) {
      // } else {
      //   store.commit(types.SHOW_MODAL, {type: 'share'});
      // }
    },
    onClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-times{
    position absolute
    width 6.66rem
    height 5.16rem
    background-image url('./images/alert.png')
    background-size: 6.66rem 4.46rem;
    background-repeat: no-repeat;
    background-position 0 0
    animation fadeIn 0.3s ease-in-out
    .box-header {
      padding-top: 0.25rem;
    }
    .box-title {
      text-align: center;
      padding-left: 0;
      margin-bottom: 0;
      font-size: 0.32rem;
      font-weight: 700;
      color: #333;
      letter-spacing 0.04rem
    }
    .box-content{
      min-height: 1.76rem;
      padding-top: 1rem;
      word-break: break-all;
      line-height: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size 0.26rem;
      color: #c22516;
      font-weight bold;
      width: 79%;
      margin: 0 auto;
    }
    .box-bottom{
      // border-top: 1px solid #ddd;
      width: 100%;
      height: 0.8rem;
      line-height 0.8rem
      display: flex;
      align-items: center;
      justify-content: center;
      color: #26a2ff;
      letter-spacing 0.04rem;
      margin-top 0.8rem;
      // top 2.82rem
      // position absolute
      .bottom-item {
        width: 2.32rem;
        height: 0.86rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image url('./images/go.png')
        background-size 100% 100%
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
